import { ASSET_TYPE_ID } from "../../const";

export const APPLICATION_JSON = "application/json";
export const MULTIPART = "multipart/form-data";
export const IMAGE_MIME_TYPES = "image/png, image/jpeg, image/jpg, image/gif";
export const AUDIO_MIME_TYPES = "audio/mp3";
export const PDF_MIME_TYPES = "application/pdf";
export const VIDEO_MIME_TYPES = "video/mp4";
export const SVG_MIME_TYPES = "image/svg+xml";
export const DEFAULT_MEDIA_MIME_TYPES = `${IMAGE_MIME_TYPES}, ${AUDIO_MIME_TYPES}, ${PDF_MIME_TYPES}, ${VIDEO_MIME_TYPES}, ${SVG_MIME_TYPES}`;

export const mimeTypesMapping = {
  [ASSET_TYPE_ID.IMAGE]: IMAGE_MIME_TYPES,
  [ASSET_TYPE_ID.PANORAMIC_IMAGE]: IMAGE_MIME_TYPES,
  [ASSET_TYPE_ID.AUDIO]: AUDIO_MIME_TYPES,
  [ASSET_TYPE_ID.PDF]: PDF_MIME_TYPES,
  [ASSET_TYPE_ID.VIDEO]: VIDEO_MIME_TYPES,
  [ASSET_TYPE_ID.SMART_OBJECT]: SVG_MIME_TYPES,
} as const;
